import CheckIdDatosMaestrosScreen from "@/components/checkid/CheckIdDatosMaestrosScreen";

export default function DatosMaestrosValidadorCheckIdPage() {
  return <CheckIdDatosMaestrosScreen />;
}
